import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./AddClient.module.css";
import MoreDropDown from "./MoreDropDown";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
)

export default function AddClient() {
    const navigateTo = useNavigate();
    const [selectedClient, setselectedClient] = useState(null);
    const [title, setTitle] = useState("");
    const [amount, setAmount] = useState("");
    const [dateAdded, setdateAdded] = useState("");
    const [dateStarted, setdateStarted] = useState("");
    const [dateDue, setdateDue] = useState("");
    const [dateCompleted, setdateCompleted] = useState("");
    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);
    const [dragging, setDragging] = useState(false);

    const clients = [
        { id: 1, name: "John Smith", email: "johnsmith@gmail.com" },
        { id: 2, name: "Jane Doe", email: "janedoe@gmail.com" }
    ];

    const subs = ["No Subscriptions", "Subscription 1", "Subscription 2", "Subscription 3"];

    const handleBackClick = () => navigateTo("/clients");
    // File Drag & Drop Handlers
    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = () => {
        setDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    };

    // File Input Change
    const handleFileChange = (e) => {
        setFiles((prevFiles) => [...prevFiles, ...Array.from(e.target.files)]);
    };

    // Trigger file input click when clicking "Browse"
    const handleBrowseClick = () => {
        fileInputRef.current.click();
    };

    // Form Submit Handler
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data:", {

        });
    };



    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <button onClick={handleBackClick} className={Classes.backButton}>
                    <LeftArrow height='13px' fill='#969696' />
                    <h5>Clients</h5>
                </button>
            </div>
            <div className={Classes.hero2}>
                <h3>Add client</h3>

                <form onSubmit={handleSubmit}>
                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Email</label>
                        <input
                            type="text"
                            className={Classes.inputField}
                            placeholder="johndoe@example.com"
                        />
                    </div>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <div className="flexAlign10" >
                                <label className={Classes.label}>First name</label>
                                <div className={Classes.optionalText} > <h5>Optional</h5> </div>
                            </div>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="John"
                            />
                        </div>
                        <div className={Classes.flexCol1}>
                            <div className="flexAlign10" >
                                <label className={Classes.label}>Last name</label>
                                <div className={Classes.optionalText} > <h5>Optional</h5> </div>
                            </div>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="Doe"
                            />
                        </div>
                    </div>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <div className="flexAlign10" >
                                <label className={Classes.label}>Billing address</label>
                                <div className={Classes.optionalText} > <h5>Optional</h5> </div>
                            </div>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="Address"
                            />
                        </div>
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label} style={{ color: 'white' }} >.</label>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="City"
                            />
                        </div>
                    </div>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="Country"
                            />
                        </div>
                        <div className={Classes.flexCol1}>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="State / Province / Region"
                            />
                        </div>
                        <div className={Classes.flexCol1}>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="Postal / Zip Code"
                            />
                        </div>
                    </div>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="Company"
                            />
                        </div>
                        <div className={Classes.flexCol1}>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="Tax ID"
                            />
                        </div>
                    </div>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <div className="flexAlign10" >
                                <label className={Classes.label}>Phone</label>
                                <div className={Classes.optionalText} > <h5>Optional</h5> </div>
                            </div>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="Phone"
                            />
                        </div>
                        <div className={Classes.flexCol1}>

                        </div>
                    </div>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <div className="flexAlign10" >
                                <label className={Classes.label}>Password</label>
                                <div className={Classes.optionalText} > <h5>Optional</h5> </div>
                            </div>

                            <div>
                                <input
                                    type="password"
                                    className={Classes.inputField}
                                    placeholder="Password"
                                />
                                <h5 className={Classes.miniText} > Leave this empty to sign in with a magic link </h5>
                            </div>
                        </div>
                        <div className={Classes.flexCol1}>

                        </div>
                    </div>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <div className="flexAlign10" >
                                <label className={Classes.label}>Assign from</label>
                                <div className={Classes.optionalText} > <h5>Optional</h5> </div>
                            </div>
                            <MoreDropDown />
                        </div>
                        <div className={Classes.flexCol1}>

                        </div>
                    </div>

                    <label className={Classes.label}>Upload client documents</label>
                    {/* File Upload Section */}
                    <div
                        className={`${Classes.fileUpload} ${dragging ? Classes.dragActive : ""}`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={handleBrowseClick} // Trigger file input on click
                    >
                        <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            className={Classes.fileInput}
                            ref={fileInputRef} // Connect input ref
                        />
                        <h5>
                            <span className={Classes.browseText}>Browse</span> or drag and drop files here
                        </h5>
                    </div>

                    {/* File List Preview */}
                    {files.length > 0 && (
                        <ul className={Classes.fileList}>
                            {files.map((file, index) => (
                                <li key={index}>{file.name}</li>
                            ))}
                        </ul>
                    )}

                    <div className={Classes.flexEnd}>
                        <button type="submit" className={Classes.submitBtn}>
                            <h5>Add client</h5>
                        </button>
                    </div>
                </form>
            </div>
        </div >
    );
}
